import { mountApp } from "./app/App";
import "@decizyon/ui-contract/tokens.css";
import "@decizyon/support-chat/register";

const container = document.querySelector<HTMLElement>("#app");
if (!container) {
  throw new Error("Application root #app was not found");
}

mountApp(container);
